export default __webpack_public_path__ + "static/logo-post-a69f5013e21da3b083b97c7b4217f9ae.png";